export default "__VITE_ASSET__CbO1mA41__"